import { IThongKeSoLuongSinhVienRequest } from "../../../model/request/bao-cao/IThongKeSoLuongSinhVienRequest";
import { IThongKeSoLuongSinhVienKetQua } from "../../../model/respone/bao-cao/IThongKeSoLuongSinhVien";
import { IThongKeSoLuongSinhVienActionTypes } from "../../action-types/bao-cao/IThongKeSoLuongSinhVienActions";
import { IThongKeSoLuongSinhVienReducer } from "../../reducer-model/bao-cao/IThongKeSoLuongSinhVienReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IThongKeSoLuongSinhVienReducer = {
  status: eReducerStatusBase.is_not_initialization,
  statusExport: eReducerStatusBase.is_completed,
  request: {
    hoc_ky: 0,
    nam_hoc: "",
    id_hes: [],
    id_khoas: [],
    khoa_hocs: [],
    id_nganhs: [],
    id_chuyen_nganhs: [],
    id_lops: [],
    // Mặc định theo đúng biểu giấy: Khoa → Khóa → Ngành.
    nhom_theo: "khoa_nganh",
  },
};

export const thongKeSoLuongSinhVienReducer = (
  state: IThongKeSoLuongSinhVienReducer = iniState,
  action: IThongKeSoLuongSinhVienActionTypes,
): IThongKeSoLuongSinhVienReducer => {
  switch (action.type) {
    case "THONG_KE_SL_SINH_VIEN_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...(action.payload as Partial<IThongKeSoLuongSinhVienRequest>),
        },
        // Đổi bộ lọc là dựng lại biểu; số liệu cũ để lại dễ đọc nhầm.
        status: eReducerStatusBase.is_need_reload,
      };
    case "THONG_KE_SL_SINH_VIEN_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "THONG_KE_SL_SINH_VIEN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        ketQua: action.payload as IThongKeSoLuongSinhVienKetQua,
      };
    case "THONG_KE_SL_SINH_VIEN_LOAD_ERROR":
      // Lỗi thì coi như xong để bỏ vòng quay; thông báo đã bắn ở saga.
      return { ...state, status: eReducerStatusBase.is_completed };

    case "THONG_KE_SL_SINH_VIEN_EXPORT_EXCEL_START":
    case "THONG_KE_SL_SINH_VIEN_XEM_TRUOC_START":
      return { ...state, statusExport: eReducerStatusBase.is_loading };
    case "THONG_KE_SL_SINH_VIEN_EXPORT_EXCEL_SUCCESS":
    case "THONG_KE_SL_SINH_VIEN_EXPORT_EXCEL_ERROR":
    case "THONG_KE_SL_SINH_VIEN_XEM_TRUOC_ERROR":
      return { ...state, statusExport: eReducerStatusBase.is_completed };
    case "THONG_KE_SL_SINH_VIEN_XEM_TRUOC_SUCCESS":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
        printHtml: action.payload as string,
      };
    case "THONG_KE_SL_SINH_VIEN_DONG_XEM_TRUOC":
      return { ...state, printHtml: undefined };

    default:
      return state;
  }
};
